import { render, staticRenderFns } from "./ImportTemplate.vue?vue&type=template&id=bdb933c8&scoped=true&"
import script from "./ImportTemplate.vue?vue&type=script&lang=js&"
export * from "./ImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImportTemplate.vue?vue&type=style&index=0&id=bdb933c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb933c8",
  null
  
)

export default component.exports